var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartAssessment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4674_12967)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156.925 116.57V38.1719",
    stroke: "#7f56d9",
    strokeWidth: 5.85937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4674_12967",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 201,
    height: 200
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.499023 1.52588e-05H200.499V200H0.499023V1.52588e-05Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4674_12967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7139 153.898V10.8164C11.7139 6.45704 15.2451 2.9258 19.6084 2.9258H149.034C153.394 2.9258 156.925 6.45704 156.925 10.8164V24.5",
    stroke: "#7f56d9",
    strokeWidth: 5.85937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7139 167.574V189.18C11.7139 193.539 15.2451 197.07 19.6084 197.07H149.034",
    stroke: "#7f56d9",
    strokeWidth: 5.85937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9692 28.1832V18.7129C36.9692 16.9695 38.3825 15.5563 40.1259 15.5563H128.515C130.259 15.5563 131.672 16.9695 131.672 18.7129V28.1832C131.672 29.9266 130.259 31.3398 128.515 31.3398H40.1259C38.3825 31.3398 36.9692 29.9266 36.9692 28.1832Z",
    stroke: "#7f56d9",
    strokeWidth: 5.85937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7529 97.6328H40.126V85.0059H52.7529V97.6328Z",
    stroke: "#7f56d9",
    strokeWidth: 5.85937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0073 97.6328H65.3804V74.7465H78.0073V97.6328Z",
    stroke: "#7f56d9",
    strokeWidth: 5.85937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.261 97.6328H90.6343V59.7516H103.261V97.6328Z",
    stroke: "#7f56d9",
    strokeWidth: 5.85937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.516 97.6328H115.889V47.1246H128.516V97.6328Z",
    stroke: "#7f56d9",
    strokeWidth: 5.85937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2666 116.574H51.9639",
    stroke: "#7f56d9",
    strokeWidth: 5.85937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1267 116.574H32.2349",
    stroke: "#7f56d9",
    strokeWidth: 5.85937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3802 129.199H24.3423",
    stroke: "#7f56d9",
    strokeWidth: 5.85937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2667 129.199H78.0073",
    stroke: "#7f56d9",
    strokeWidth: 5.85937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2669 141.828H47.229",
    stroke: "#7f56d9",
    strokeWidth: 5.85937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6012 141.828H24.3418",
    stroke: "#7f56d9",
    strokeWidth: 5.85937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3802 154.453H24.3423",
    stroke: "#7f56d9",
    strokeWidth: 5.85937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2667 154.453H78.0073",
    stroke: "#7f56d9",
    strokeWidth: 5.85937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.299 97.6328H24.3423",
    stroke: "#7f56d9",
    strokeWidth: 5.85937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.714 178.832C186.867 172.504 189.285 164.938 189.285 156.82C189.285 134.629 171.226 116.574 149.035 116.574C126.843 116.574 108.785 134.629 108.785 156.82C108.785 179.016 126.843 197.07 149.035 197.07C158.21 197.07 166.675 193.984 173.453 188.793",
    stroke: "#7f56d9",
    strokeWidth: 5.85937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.036 141.414L143.702 155.747L140.033 152.078C137.071 149.116 132.268 149.116 129.306 152.078C126.343 155.041 126.343 159.843 129.306 162.805L139.009 172.509C141.601 175.101 145.803 175.101 148.395 172.509L168.763 152.141C171.725 149.179 171.725 144.376 168.763 141.414C165.8 138.452 160.998 138.452 158.036 141.414Z",
    stroke: "#7f56d9",
    strokeWidth: 5.85937,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4674_12967"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartAssessment);
export default __webpack_public_path__ + "static/media/chartAssessment.8bd79c527eaa1819653e0e715eedd370.svg";
export { ForwardRef as ReactComponent };